import { rtkApi } from '@/apis/rtkApi';
import {
  GetProductsByAdminRequest,
  GetProductsByAdminResponse,
} from '@/types/ProductType';

export const adminProductApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    getProductsByAdmin: builder.query<
      GetProductsByAdminResponse,
      GetProductsByAdminRequest
    >({
      query: (payload) => ({ url: `/admin/product`, params: payload }),
      providesTags: ['Admin Product'],
    }),
    updateProductByAdmin: builder.mutation<
      void,
      { id: string; name?: string; price?: number; agent?: string }
    >({
      query: ({ id, ...data }) => ({
        url: `/admin/product/${id}`,
        method: 'PUT',
        data,
      }),
      invalidatesTags: ['Admin Product'],
    }),
  }),
  overrideExisting: true,
});

export const { useGetProductsByAdminQuery, useUpdateProductByAdminMutation } =
  adminProductApi;
